<template>
    <b-card no-body class="overflow-hidden">
        <b-modal id="errors" size="lg" hide-footer body-class="p-0" title="Personel Hatalar" no-close-on-esc no-close-on-backdrop>
            <kasa-dekont-errors v-model="current"></kasa-dekont-errors>
        </b-modal>

        <b-overlay :show="getting">
            <div class="p-1 row">
                <div class="col-md-1 mb-1 mb-md-0">
                    <select class="form-control bg-img-none" v-model="month">
                        <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                    </select>
                </div>
                <div class="col-md-1 mb-1 mb-md-0">
                    <select class="form-control bg-img-none" v-model="year">
                        <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                    </select>
                </div>
                <div class="col-md-auto">
                    <button class="btn btn-success" v-on:click="send">Gönder</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-sm bordered-header">
                    <thead>
                        <tr>
                            <th>Şube</th>
                            <th>Yaka</th>
                            <th class="w-100">Sonuç</th>
                            <th class="text-nowrap">Personel Hataları</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(d,i) in datas">
                            <template v-for="(item,ii) in ($safe(d,'Items') || [])">
                                <tr>
                                    <td class="align-top border-right text-nowrap bg-muted font-weight-bolder" v-if="ii == 0" :rowspan="($safe(d,'Items') ||[]).length">{{ $safe(d,'BranchName') || '-' }}</td>
                                    <td class="text-nowrap border-right">{{ $safe(item,'CollarStatusName') || '-' }}</td>
                                    <td class="text-danger text-nowrap border-right">{{ $safe(item,'Result') }}</td>
                                    <td>
                                        <template v-if="($safe(item,'EmployeeErrors') || []).length">
                                            <button v-on:click="showErrors(item)" class="btn btn-outline-secondary btn-sm text-nowrap w-100">Toplam {{ ($safe(item,'EmployeeErrors') || []).length }} Adet</button>
                                        </template>
                                        <span v-else class="text-success text-nowrap">Hata bulunmamaktadır.</span>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <template v-if="(datas || []).length == 0">
                            <tr>
                                <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import { BCard, BOverlay } from 'bootstrap-vue'
import moment from 'moment'
import EmployeeOperationsApi from '@/api/employee-operations'
import KasaDekontErrors from './components/KasaDekontErrors.vue'

export default {
    components:{
        BCard,
        BOverlay,
        KasaDekontErrors
    },
    data(){
        return {
            getting:false,
            datas:[],
            current:null,
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            years:[],
            year:moment().year(),
            month: moment().month() + 1
        }
    },
    mounted(){
        this.configureYears()
    },
    methods:{
        send(){
            this.getting = true
            EmployeeOperationsApi.GSalary.KasaDekont(this.month, this.year).then(res => {
                this.datas = res.data.Data || []
                
                this.getting =false
            }).catch(err =>{
                this.$result(null,err)
                this.getting = false
            })
        },
        showErrors(item){
            this.current = null
            this.current = item
            this.$showModal('errors')
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
    }
}
</script>

<style>
.bg-muted{
    background-color: #f3f2f7;
}

.dark-layout .bg-muted{
    background-color: #343d55 !important;
}
</style>